var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrowPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#D4366A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.23 6.033a2.082 2.082 0 0 1 2.943 0l7.85 7.85a2.082 2.082 0 0 1 0 2.944l-7.85 7.85a2.082 2.082 0 0 1-2.944-2.944l4.297-4.297H7.158a2.082 2.082 0 0 1 0-4.163h11.368l-4.297-4.296a2.082 2.082 0 0 1 0-2.944Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowPink);
export default __webpack_public_path__ + "static/media/right-arrow-pink.f248e35df37db6279c5d0b8e2fd32904.svg";
export { ForwardRef as ReactComponent };